import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { Spin } from 'antd';

import store, { history, persistor } from './store';

// import './style/default.less';
import './style/index.less';
import './assets/theme.css';

import Routing from './components/Routing';

class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={<Spin spinning={true} />} persistor={persistor}>
          <ConnectedRouter history={history}>
            <Routing />
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
